import {Footer} from "@/components/layouts/main/Footer";
import {Header} from "@/components/layouts/main/Header";

import {useEffect} from "react";

import {BackButton} from "@ui/buttons/BackButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Logo} from "@ui/general/Logo";
import {H2} from "@ui/titles/H2";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

import styles from "./styles.module.scss";

export const Terms = () => {
  const {t} = useTranslation();
  const {auth} = useSelector((state) => state.common.candidate);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [location]);

  return (
    <>
      <div className={"container-big"}>
        <div className={styles.privacyWrapper}>
          {auth ? (
            <Header />
          ) : (
            <div className={styles.privacyHead}>
              <Logo />
            </div>
          )}

          <BorderArticle>
            <div className={styles.privacy}>
              <BackButton />

              {t("page.terms.title_1") !== "" && (
                <div className={styles.privacyTitle}>
                  <H3>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("page.terms.title_1"),
                      }}
                    />
                  </H3>
                </div>
              )}

              {t("page.terms.title_2") !== "" && (
                <h1
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.title_2"),
                  }}
                />
              )}

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.desc_1"),
                  }}
                />

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_1"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_2"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_3"),
                    }}
                  />
                </ul>

                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.desc_2"),
                  }}
                />

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_4"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_5"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_6"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_7"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.terms.l_1_8"),
                    }}
                  />
                </ul>
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_1"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_1"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_2"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_2"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_3"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_3"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_4"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_4"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_5"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_5"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_6"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_6"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_7"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_7"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_8"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_8"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_9"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_9"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_10"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_10"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_11"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_11"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_12"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_12"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.p_13"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.terms.d_13"),
                  }}
                />
              </RootDesc>
            </div>
          </BorderArticle>
        </div>
      </div>

      <Footer />
    </>
  );
};
